import * as z from "zod";

export const getProductIdToProductAsVariantProductIds = {
  name: "getProductIdToProductAsVariantProductIds" as const,
  input: z.object({ productIds: z.array(z.string()) }),
  output: z.object({
    productIdToProductAsVariantProductIds: z.map(
      z.string(),
      z.object({ collectionId: z.string(), productIds: z.array(z.string()) }),
    ),
  }),
};
